export const FEATURE_GATES = {
  shadowingProfessional: { speakingScore: 0.60, speakingCefr: 'B1' as const },
} as const;
